export default __webpack_public_path__ + "static/media/Milky.9bb833c5.png";